import { useState, useEffect } from "react";
export default function useFocusPath(focusManager, onFocusUpdate) {
    const [focusPath, setFocusPath] = useState(() => focusManager.getFocusPath());
    useEffect(() => {
        return focusManager.subscribe(() => {
            const newFocusPath = focusManager.getFocusPath();
            setFocusPath(newFocusPath);
            if (onFocusUpdate)
                onFocusUpdate({ focusPath: newFocusPath });
        });
    }, [focusManager, onFocusUpdate]);
    return focusPath;
}
